import { uniqBy } from "lodash";

import { Path } from "services/path";
import { BestBikingRoads } from "services/best-biking-road";
import { IRouteDay, IGeneralRouteData, ISameRoad } from "types";

export class GeneralRouteData {
  constructor(
    private path: Path,
    private days: IRouteDay[],
    private sameRoads: ISameRoad,
    private bestBikingRoads?: BestBikingRoads
  ) {
    this.days = days;
    this.path = path;
    this.sameRoads = sameRoads;
    this.bestBikingRoads = bestBikingRoads;
  }

  public generateData(): IGeneralRouteData {
    const hotels = this.days.map((item) => item.hotels).flat(1);
    const campings = this.days.map((item) => item.campings).flat(1);
    const allPlaces = this.days.map((item) => item.allPlaces).flat(1);
    const selectedPlaces = uniqBy(
      this.days.map((day) => day.selectedPlaces).flat(1),
      "id"
    );
    const suggestedPlaces = this.days
      .map((item) => item.suggestedPlaces.flat(1))
      .flat(1);

    const bestBikingRoads =
      this.bestBikingRoads?.all.map((item) => item.coordinates) ?? [];

    return {
      hotels,
      campings,
      allPlaces,
      totalTime: 0,
      selectedPlaces,
      suggestedPlaces,
      bestBikingRoads,
      points: this.path.coordinates,
      sameRoads: this.sameRoads.coordinates,
      tollRoads: this.path.tollsCoordinates,
      route: { paths: [this.path.instance] },
      totalDistance: this.path.getDistance("m"),
    };
  }
}
